import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { DynamicPlacementPopover } from '../../../shared/dynamic-placement-popover/dynamic-placement-popover';
import { SystemConfiguration } from '../../../../utils/system-configuration';

interface ServiceProps {
    servicesIds: string[];
    isServiceRule?: boolean;
    maxServicesToDisplay?: number;
}

export const ServiceCell: React.FC<ServiceProps> = observer(({ servicesIds, maxServicesToDisplay = 4, isServiceRule }) => {
    const { fwVersionStore } = useStores();

    const getServiceDisplayName = useCallback((serviceId: string) => {
        const defaultServiceName = SystemConfiguration.getInstance().data.defaultServiceDtoList.find(s => s.serviceId === serviceId)?.serviceDisplayName;
        const customDisplayName = fwVersionStore.getPureCustomServices.find(s => s.id === serviceId)?.displayName || '';
        return defaultServiceName ?? customDisplayName;
    }, []);

    const additionalServices = servicesIds.length - maxServicesToDisplay;

    const servicesPopoverContent = servicesIds.length ? servicesIds.map(serviceId =>
        <div key={serviceId}>{getServiceDisplayName(serviceId)}</div>
    ) : null;

    return servicesIds.length ?
        <DynamicPlacementPopover content={<div className={'expanded-popover'}>{servicesPopoverContent}</div>} contentHeight={servicesIds.length * 20}>
            <div className={'table-cell-elements-container'}>
                {servicesIds.slice(0, maxServicesToDisplay).map(serviceId => {
                    const serviceDisplayName = getServiceDisplayName(serviceId);
                    return serviceDisplayName && <div key={serviceId} className={'table-cell-single-element'}>{getServiceDisplayName(serviceId)}</div>;
                })}
                {additionalServices > 0 && <div className={'table-cell-single-element'}>+ {additionalServices}</div>}
            </div>
        </DynamicPlacementPopover>
        : <>{isServiceRule ? 'None' : 'Any'}</>;
});